module.exports = __webpack_public_path__ + "img/check-binarystar.1f4bb996.svg";